export default __webpack_public_path__ + "static/media/restart-button-wood.de4b51a3.png";